import { atom } from 'jotai';
import { PageLevelTraffic } from 'shared/models/page-level-traffic';

export const $PageLevelTraffic = atom<PageLevelTraffic>({} as PageLevelTraffic);
$PageLevelTraffic.debugLabel = '$PageLevelTraffic';
